import { Pipe, PipeTransform } from '@angular/core';

/**
 * Joins firstName/lastName, dropping any part that's missing instead of the
 * literal "null"/"undefined" text that `firstName + " " + lastName` produces
 * when a part is absent.
 */
export function getFullName(user: { firstName?: string; lastName?: string } | null | undefined): string {
  if (!user) return '';
  return [user.firstName, user.lastName]
    .filter(part => !!part && part.trim().length > 0)
    .join(' ');
}

/**
 * Usage: {{ asset?.createdBy | fullName }}
 */
@Pipe({
  name: 'fullName',
  standalone: true
})
export class FullNamePipe implements PipeTransform {
  transform(user: { firstName?: string; lastName?: string } | null | undefined): string {
    return getFullName(user);
  }
}
